import { render } from "./OverallBookStatistics.vue?vue&type=template&id=7c91ea9f&scoped=true"
import script from "./OverallBookStatistics.vue?vue&type=script&lang=js"
export * from "./OverallBookStatistics.vue?vue&type=script&lang=js"

import "./OverallBookStatistics.vue?vue&type=style&index=0&id=7c91ea9f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7c91ea9f"

export default script